export {
  type TenantId,
  type TenantConfig,
  TENANTS,
  DOMAIN_TO_TENANT,
  getTenantById,
  getTenantByDomain,
  getDefaultTenant,
  DEFAULT_TENANT_ID,
  DEV_TENANT_COOKIE,
  isTenantId,
} from "@/lib/tenant/config";

// Re-export types for convenience
export type { TenantConfig as TenantConfigType } from "@/lib/tenant/config";

export {
  TenantProvider,
  useTenant,
  useTenantOfferings,
  useTenantTheme,
  useTenantFeatures,
} from "@/lib/tenant/context";
